import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Page from "@insite/mobius/Page";
import * as React from "react";
import { ReactNode } from "react";
import styled from "styled-components";

/* Poolcorp Custom Code */
import { InvoicePaymentAuthorizationContext } from "@store/Components/Common/InvoicePaymentAuthorizationContext";
import AppInsightsComponent from "@store/Components/Store/ApplicationInsights";
import BloomreachPixel from "@store/Components/Store/BloomreachPixel";
import StoreCreditOnHoldMessage from "@store/Components/Store/StoreCreditOnHoldMessage";
import validateCustomerAuthorized from "@store/Handlers/CommonHandlers/ValidateCustomerAuthorized";
import useIsSignedIn from "@store/Hooks/useIsSignedIn";
import { InvoicePaymentConfirmationPageContext } from "@store/Pages/InvoicePaymentConfirmationPage";
import { getStoreSettingsCollection } from "@store/Store/Context/ContextSelectors";
import StoreApplicationState from "@store/Store/StoreApplicationState";
import { InvoicePaymentAuthorizedModel } from "@store/Types/InvoicePayment";
import { isAuthenticatedOrRemembered } from "@store/utilities/isAuthenticatedOrRemembered";
import isWebsiteAccessedByMobileApp from "@store/utilities/isWebsiteAccessedByMobileApp";
import { connect, ResolveThunks, useSelector } from "react-redux";



const mapDispatchToProps = {
    validateCustomerAuthorized,
};

/* Poolcorp Custom Code - End */
interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
}

type Props = PageLayoutProps & ResolveThunks<typeof mapDispatchToProps>; // Poolcorp Custom Code

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showSignInOverlay,
    signInOverlay,
    validateCustomerAuthorized // Poolcorp Custom Code
}: Props) => {
    /* Poolcorp Custom Code Start - Conditionnal page layout wrap if App Insight is enabled */
    const {
        appInsightsEnabled,
        appInsightsConnectionString,
        appInsightsRoleName,
        appInsightsCorsExcludedDomains,
        matomoEnabled,
        matomoSource,
    } = useSelector((state: StoreApplicationState) => getStoreSettingsCollection(state).poolcorpSettings);

    
    const isSignedIn = useIsSignedIn();
    const [invoicePaymentAuthorization, setInvoicePaymentAuthorization] = React.useState<InvoicePaymentAuthorizedModel>({canPay: false, canPayByCC: false, canPayByChk: false});
    React.useEffect(() => {
        if (matomoEnabled) {
            const _mtm = window._mtm = window._mtm || [];
            _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
            const d=document; const g=d.createElement('script'); const s=d.getElementsByTagName('script')[0];
            g.async=true; g.src=matomoSource; s.parentNode?.insertBefore(g,s);
        }

        if (isSignedIn) {
            validateCustomerAuthorized({
                onSuccess: (result: InvoicePaymentAuthorizedModel) => {
                    setInvoicePaymentAuthorization(result);
                },
            });
        }
       
    }, [])

    /* Poolcorp Custom Code End */
    const pageLayoutComponent = (
        <PageLayoutWrapper>
            <InvoicePaymentAuthorizationContext.Provider value={invoicePaymentAuthorization}>
            {showHeader && header}
            {/* Poolcorp removed - compactHeader */}
            {/* Poolcorp Custom Code - Start */}
            <StoreCreditOnHoldMessage />
            {!isWebsiteAccessedByMobileApp() && showBreadcrumbs && (
                <Page as="div">
                    <PageBreadcrumbs />
                </Page>
            )}
            {/* Poolcorp Custom Code - End */}
            {pageContent}
            {showFooter && footer}
            {/* Poolcorp removed - signInOverlay */}
            {/* Poolcorp Custom Code - Start */}
            <BloomreachPixel />
            {/* Poolcorp Custom Code - End */}
            </InvoicePaymentAuthorizationContext.Provider>
        </PageLayoutWrapper>
    );

    if (appInsightsEnabled) {
        return (
            <AppInsightsComponent connectionString={appInsightsConnectionString} roleName={appInsightsRoleName} corsExcludedDomains={appInsightsCorsExcludedDomains}>
                {pageLayoutComponent}
            </AppInsightsComponent>
        );
    }

    return pageLayoutComponent;
    /* Poolcorp Custom Code End */
};

const PageLayoutWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    > main {
        flex: 1 1 0%;
    }

    @media print {
        display: block;
    }
`;

export default connect(null, mapDispatchToProps)(PageLayout); // Poolcorp Custom Code
